import { render } from "./TheNavbarMessagesItem.pug?vue&type=template&id=a9694f04&lang=pug"
import script from "./TheNavbarMessagesItem.js?vue&type=script&lang=js"
export * from "./TheNavbarMessagesItem.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__